<div class="main-container">
  <img src="/assets/icons/icon-back.png" alt="" />
  <label>{{ title ? "Back to " + title : "Back" }}</label>
</div>
